<div class="mt-5 px-4 sm:px-6 lg:hidden">
  <wma-tabs-with-underline-vertical [links]="links()" />
</div>

<div class="hidden bg-white lg:block">
  <wma-tabs-with-underline-horizontal
    class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8"
    [links]="links()"
  />
</div>
